const callbacks = [];

export function pushModal(onClose) {
  callbacks.push(onClose);
}

// Called by back button — removes top entry and invokes it
export function popModal() {
  if (callbacks.length > 0) {
    const fn = callbacks.pop();
    fn();
    return true;
  }
  return false;
}

// Called by the modal itself when closed via UI (not back button)
// Removes the callback without calling it, so back button doesn't re-trigger
export function removeModal(onClose) {
  const idx = callbacks.lastIndexOf(onClose);
  if (idx !== -1) callbacks.splice(idx, 1);
}

export function hasOpenModal() {
  return callbacks.length > 0;
}
